import { createAsyncThunk } from '@reduxjs/toolkit';
import CommonEnumsResource from 'api/service/CommonEnumsResource';

export const listStatuses = createAsyncThunk('properties/listStatuses', async () => {
  const commonEnumsResource = new CommonEnumsResource();
  const { status, data } = await commonEnumsResource.list('property_status');
  if (status === 200) {
    return data;
  }
  return [];
});
